<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import type { MetadataFragment } from '~/lib/graphql/graphql.ts'

const props = defineProps<{
  metadata: MetadataFragment
}>()

const $player = ref<HTMLElement>()
let player: Plyr | null = null

async function createPlayer() {
    if (player) player.destroy()
    import('plyr/dist/plyr.css')
    const Plyr = (await import('plyr')).default
    player = new Plyr($player.value!)
    addPlayerEvents(player, true, props.metadata, undefined, undefined)
}

const baseUrl = useRuntimeConfig().public.audioBaseUrl

const url = computed(() => {
    const slug = props.metadata?.slug
    const type = props.metadata?.content?.type?.split('/')[1]
    if (!slug || !type) return ''
    return baseUrl + '/' + slug + '.' + type
})

onMounted(() => {
    if (typeof window === 'undefined') return
    createPlayer()
})
</script>

<template>
  <div class="audio-player">
    <audio
      ref="$player"
      class="plyr w-full m-0 p-0"
      controls
    >
      <source
        :src="url"
        type="audio/mp3"
      >
    </audio>
  </div>
</template>

<style>
.audio-player .plyr {
  @apply rounded-full;
}
</style>
